import { cn } from '../../utils/cn'
import { Input } from './input'

export interface TimeValue {
  hours: number // 0-23
  minutes: number // 0-59
}

function toInputValue({ hours, minutes }: TimeValue): string {
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
}

/**
 * shadcn-style time picker: a native `<input type="time">` (the radix
 * date-picker "time picker" pattern). Value is 24-hour {hours, minutes};
 * the browser renders it in the user's locale (12h/24h).
 */
export function TimePicker({
  value,
  onChange,
  onClear,
  id,
  className,
  disabled,
}: {
  /** null shows an empty field, for a time that isn't known. */
  value: TimeValue | null
  onChange: (value: TimeValue) => void
  /** Makes the field clearable: called when it's emptied. */
  onClear?: () => void
  id?: string
  className?: string
  disabled?: boolean
}) {
  return (
    <Input
      type="time"
      id={id}
      disabled={disabled}
      aria-label="Time"
      value={value ? toInputValue(value) : ''}
      onChange={(e) => {
        const next = e.target.value // "HH:MM" or "" when cleared
        if (!next) {
          onClear?.()
          return
        }
        const [h, m] = next.split(':')
        const hours = Number(h)
        const minutes = Number(m)
        if (Number.isNaN(hours) || Number.isNaN(minutes)) return
        onChange({ hours, minutes })
      }}
      className={cn(
        'appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none',
        className
      )}
    />
  )
}
